/* eslint-disable no-param-reassign */
/* eslint-disable jsdoc/require-jsdoc */
/**
 * This script is used for adding a data-attribute to all <select> elements which tells us if the placeholder <option> element is currently selected. We can use this in our CSS to style the placeholder differently if the data-attribute is true.
 */

window.addEventListener('load', () => {
  const selectFields = [...document.querySelectorAll('.gfield_select')];

  if (selectFields.length === 0) {
    return;
  }

  const placeholderCheck = (selectField) => {
    // Get the placeholder <option> element.
    const placeholderEl = [...selectField.childNodes].filter(
      (el) => el.className === 'gf_placeholder',
    );
    // Check if that is the one currently selected.
    if (placeholderEl[0] === selectField.options[selectField.selectedIndex]) {
      selectField.dataset.placeholderSelected = 'true';
    } else {
      selectField.dataset.placeholderSelected = 'false';
    }
  };

  selectFields.forEach((selectField) => {
    placeholderCheck(selectField);
    selectField.addEventListener('change', () => placeholderCheck(selectField));
  });
});
